import { useCheckPermissions } from '@/shared';
import { SaveMantenimiento } from '../../shared/saveMantenimiento';
import { PermissionsEnum } from '@/auth/interfaces';

export interface CreateMantenimientoPage {}

const CreateMantenimientoPage: React.FC<CreateMantenimientoPage> = () => {
  useCheckPermissions(PermissionsEnum.api_add_ice)

  return <SaveMantenimiento titlePage="Crear Mantenimiento" />;
};

export default CreateMantenimientoPage;
